import { ModuleRegistry } from "ag-grid-community";
import {
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MultiFilterModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
  TreeDataModule,
} from "ag-grid-enterprise";
import { forwardRef, useCallback, useMemo, useState } from "react";

import { KeyboardArrowRight } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { isNil } from "lodash";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { agApiSizeColumnsToFit } from "../../../../_src_shared/utils/agGrid/api/agApiSizeColumnsToFit";
import AgGridTableWrapper from "../../../../components/agGrid/AgGridTableWrapper";
import PinnedCommentsModal from "../../../../components/common/Loan/Comments/PinnedCommentsModal";
import PropertyAssociatedCommentsBadge from "../../../../components/common/Loan/PropertyAssociatedCommentsBadge";

ModuleRegistry.registerModules([
  SideBarModule,
  RowGroupingPanelModule,
  MultiFilterModule,
  RowGroupingModule,
  PivotModule,
  TreeDataModule,
  FiltersToolPanelModule,
  ColumnsToolPanelModule,
  SetFilterModule,
]);

const LoanPropertiesMinimalTable = forwardRef(
  (
    { rowData, quickFilterText, simpleTable = true, height, sx, gridOptions },
    ref
  ) => {
    const navigate = useNavigate();
    const { id: loanId } = useParams();
    const [associatedComments, setAssociatedComments] = useState(null);
    const loanDrilldown = useSelector((state) => state.loanDrilldown);
    const columnDefs = useMemo(
      () => [
        {
          field: "address",
          headerName: "Address",
          flex: 1,
          minWidth: 200,
          autoHeight: true,
          cellRenderer: (params) => {
            return (
              <>
                {params.data?.address?.fullAddress}{" "}
                <PropertyAssociatedCommentsBadge
                  propertyId={params.data?._id}
                  onClick={(c) => {
                    console.log(c);
                    setAssociatedComments({
                      comments: c,
                      propertyId: params.data?._id,
                    });
                  }}
                />
              </>
            );
          },
        },
        {
          field: "arrow",
          flex: 0,
          width: 100,
          cellStyle: { cursor: "pointer" },
          cellRenderer: () => {
            return (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  pr: 2.5,
                }}
              >
                <Tooltip title="Go To Property Details">
                  <KeyboardArrowRight className="thin" />
                </Tooltip>
              </Box>
            );
          },
        },
      ],
      []
    );

    const onCellClicked = useCallback(
      (params) => {
        if (params?.colDef?.field === "arrow") {
          setAssociatedComments(null);
          navigate(`/loan/${loanId}/properties/${params?.data?._id}`);
          return;
        }
      },
      [loanId, setAssociatedComments]
    );

    const onFirstDataRendered = useCallback((params) => {
      agApiSizeColumnsToFit(params);
    }, []);

    return (
      <>
        <AgGridTableWrapper height={height} simpleTable={simpleTable} sx={sx}>
          <AgGridReact
            ref={ref}
            rowData={rowData}
            columnDefs={columnDefs}
            quickFilterText={quickFilterText}
            allowDragFromColumnsToolPanel={false}
            gridOptions={gridOptions}
            onFirstDataRendered={onFirstDataRendered}
            // onRowClicked={onRowClicked}
            onCellClicked={onCellClicked}
            headerHeight={0}
          />
        </AgGridTableWrapper>
        {!isNil(associatedComments) && (
          <PinnedCommentsModal
            title="Property Comments"
            show={associatedComments}
            fixed
            comments={associatedComments.comments}
            loan={loanDrilldown}
            // fileId={fileId}
            subjectPropertyIds={[associatedComments.propertyId]}
            onClose={() => setAssociatedComments(null)}
          />
        )}
      </>
    );
  }
);

export default LoanPropertiesMinimalTable;
